export default {
  base: {
    fontFamily: 'base',
    color: 'grey-60',
    fontSize: 16,
    lineHeight: 1.5,
    height: 58,
    width: '100%',
    border: '1px solid #000',
    borderRadius: 0,
    background: '#fff',
    appearance: 'none',
    outlineWidth: 0,
    outlineStyle: 'solid',
    outlineOffset: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    variant: 'spark.base.wrapper',
    svg: {
      position: 'absolute',
      fontSize: 20,
      color: '#000',
      zIndex: 1,
      left: 18,
      pointerEvents: 'none',
      ':last-of-type': {
        left: 'auto',
        right: 18
      }
    },
    select: {
      appearance: 'none',
      width: '100%',
      height: '100%',
      background: 'transparent',
      border: 'none',
      outline: 'none',
      padding: 16,
      paddingRight: 48,
      fontFamily: 'inherit',
      color: 'inherit',
      fontSize: 'inherit',
      lineHeight: 'inherit'
    },
    span: {
      padding: 16,
      paddingRight: 48,
      width: '100%',
      height: '100%',
      cursor: 'default'
    },
    focus: {
      outlineWidth: 1,
      outlineColor: 'cyan'
    }
  },
  variants: {
    withIcon: {
      variant: 'spark.element.select.base',
      select: {
        variant: 'spark.element.select.base.select',
        paddingLeft: 48
      },
      focus: {
        variant: 'spark.element.select.base.focus'
      }
    },
    selected: {
      variant: 'spark.element.select.base',
      backgroundColor: 'grey-05',
      color: 'grey-100',
      focus: {
        variant: 'spark.element.select.base.focus'
      }
    },
    selectedWithIcon: {
      variant: 'spark.element.select.variants.selected',
      select: {
        variant: 'spark.element.select.variants.withIcon.select'
      }
    },
    wrapper: {
      width: '100%',
      maxWidth: '100%',
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    }
  }
};